export const integraciones = {
    text1: "Integracje.",
    text2: "Skontaktuj się z programistami, aby wykonać integrację ze swoim",
    text3: "PMS",
    text4: "Kontakt",
    text5: "Poproś o integrację",
    text6: "Zebrane dane",
    text7: "Dane wnioskodawcy",
    text8: "Imię i nazwisko",
    text9: "Powód zgłoszenia",
    text10: "Opisz, dlaczego integracja jest potrzebna",
    text11: "Zamknij",
    text12: "Wyślij prośbę o integrację",
    text13: "Zarejestrowano poprawnie",
    text14: "Błąd zgłoszenia",
};
